import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { faSearch } from '@fortawesome/pro-solid-svg-icons';

import LoadingSpinner from 'components/loading_spinner';
import EmptyState from 'shared/empty_state';

import DuplicatesPageHeader from './duplicates_page_header';
import DuplicatesPageTopbar from './duplicates_page_topbar';
import DuplicatesTable from './duplicates_table';

import { getDuplicateCompaniesCount, isLoading } from '../../store/selectors/duplicates';
import DuplicatesPagination from 'bundles/contact/index/companies/duplicates/duplicates_pagination';

export function DuplicateCompaniesView({ isLoading, totalCount }) {
  const renderEmptyState = () => (
    <div className="p-4" name="no-results-card">
      <EmptyState header="No duplicate companies found" icon={faSearch} />
    </div>
  );

  const renderTable = () => (
    <>
      <DuplicatesTable />
      <DuplicatesPagination />
    </>
  );

  const renderResults = () => {
    if (isLoading) return <LoadingSpinner />;
    if (totalCount > 0) return renderTable();
    return renderEmptyState();
  };

  return (
    <>
      <DuplicatesPageHeader />
      <DuplicatesPageTopbar />
      {renderResults()}
    </>
  );
}

DuplicateCompaniesView.propTypes = {
  isLoading: PropTypes.bool,
  totalCount: PropTypes.number.isRequired
};

const mapStateToProps = state => ({
  isLoading: isLoading(state),
  totalCount: getDuplicateCompaniesCount(state)
});

export default connect(mapStateToProps)(DuplicateCompaniesView);
